// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--xesgA","text":"text--2wyDW"};